import type { SerializedStyles, Theme } from '@emotion/react';
import { css } from '@emotion/react';

import { breakpoint } from '@twistopayments/design-system/styles';

import type { BannerSize, BannerVariant } from '../../banner';

export const container = css`
  display: grid;
  justify-items: center;
  align-items: center;
  grid-area: icon;
  align-self: center;
`;

export const containerSize = (theme: Theme) => css`
  width: ${theme.spacing[32]};
  height: ${theme.spacing[32]};
  border-radius: ${theme.borderRadius.circle};

  ${breakpoint.up('sm')} {
    width: ${theme.spacing[40]};
    height: ${theme.spacing[40]};
  }
  ${theme.presentation.banner.iconFrame}
`;

export const containerBackground: Record<BannerVariant, (theme: Theme) => SerializedStyles> = {
  primary: (theme) => css`
    background-color: ${theme.presentation.banner.iconPrimaryBackground};
  `,
  secondary: (theme) => css`
    background-color: ${theme.presentation.banner.iconSecondaryBackground};
  `,
  warning: (theme) => css`
    background-color: ${theme.palette.warning.mediumContrast};
  `,
  error: (theme) => css`
    background-color: ${theme.palette.error.mediumContrast};
  `,
};

export const iconColor: Record<BannerVariant, (theme: Theme) => SerializedStyles> = {
  primary: (theme) => css`
    color: ${theme.palette.primary.mainContrast};
  `,
  secondary: (theme) => css`
    color: ${theme.presentation.banner.iconSecondaryColor};
  `,
  warning: (theme) => css`
    color: ${theme.palette.warning.main};
  `,
  error: (theme) => css`
    color: ${theme.palette.error.main};
  `,
};

export const iconSize: Record<BannerSize, (theme: Theme) => SerializedStyles> = {
  small: (theme: Theme) => css`
    width: ${theme.spacing[24]};
    height: ${theme.spacing[24]};
  `,
  medium: (theme: Theme) => css`
    width: ${theme.spacing[20]};
    height: ${theme.spacing[20]};

    ${breakpoint.up('sm')} {
      width: ${theme.spacing[24]};
      height: ${theme.spacing[24]};
    }
    ${theme.presentation.banner.iconMedium}
  `,
};
